export default function ImpactReporth2(props) {
    //console.log('ImpactReporth2 props:', props);

    const hyphenateAndLowercase = (str) => {
        return str.replace(/[^a-zA-Z\s]/g, '').replace(/\s+/g, '-').toLowerCase();
      }

    const id = hyphenateAndLowercase(props.children);

    return (
        <h2 
            style={props.style} 
            className={`impact-report-template impact-h2${props.className ? ' ' + props.className : ''}`}
            id={id}
        >
            {props.children}
        </h2>
    );

}